import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/loader/Loader";
import Loader2 from "../../components/loader/Loader2";
import CustomTableCheckbox from "../../components/custom-table/CustomTableCheckbox";
import formatDate from "../../../utils/formatDate";
import { getUSDTWithdrawalRequest, proceedUSDTPayout, returnUSDTWithdrawals } from "../../../services/Admin";


function USDTWithdrawal() {
  const [loading, setLoading]         = useState(true);
  const [processing, setProcessing]   = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  // 1️⃣ fetch pending withdrawals
  const fetchWithdrawals = async () => {
    setLoading(true);
    try {
      const reqs = await getUSDTWithdrawalRequest(); // [ { _id, userId, amount, transactionRemark, createdAt, withdrawAddress } ]
      const request = reqs.requests
      const formatted = request.map((r, i) => ({
        sno:               i + 1,
        _id:            r._id,
        userId:            r.userId,
        userName:            r.userName || "No Name",
        amount:            r.amount.toFixed(2) || "0",
        date:              formatDate(r.createdAt),
        transactionRemark: r.transactionRemark || "-",
        walletAddress:   r.walletAddress,
      }));
      setWithdrawals(formatted);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load withdrawal requests");
    } finally {
      setLoading(false);
    }
  };

  // 2️⃣ Approve (process) selected
  const handleApprove = async () => {
    setProcessing(true);
    // build payload: { _id, userId, requestAmountUSDT }
    const payloads = selectedRows
      .map(row => {
        const { _id, userId, amount, walletAddress } = row.original;
        if (!walletAddress) {
          toast.error(`User ${userId} has no withdraw address`);
          return null;
        }
        return { _id, userId, requestAmountUSDT: parseFloat(amount), walletAddress };
      })
      .filter(Boolean);

    if (!payloads.length) {
      toast.warn("No valid rows selected");
      setProcessing(false);
      return;
    }

    try {
      const processed = await proceedUSDTPayout(payloads);
      console.log(processed)
      toast.success(`${processed.length} payouts approved`);
      await fetchWithdrawals();
    } catch (err) {
      console.error(err);
      toast.error("Error approving payouts");
    } finally {
      setProcessing(false);
    }
  };

  // 3️⃣ Return (reject) selected
  const handleReturn = async () => {
    setProcessing(true);
    const payloads = selectedRows.map(row => ({ _id: row.original._id }));
    if (!payloads.length) {
      toast.warn("No rows selected");
      setProcessing(false);
      return;
    }

    try {
      const returned = await returnUSDTWithdrawals(payloads);
      toast.success(`${returned.length} payouts returned`);
      await fetchWithdrawals();
    } catch (err) {
      console.error(err);
      toast.error("Error returning payouts");
    } finally {
      setProcessing(false);
    }
  };

  // collect selected rows
  const onSelectedRows = selectedFlatRows => {
    setSelectedRows(selectedFlatRows);
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  if (loading) return <Loader />;

  const columns = [
    { Header: "S.No",             accessor: "sno" },
    { Header: "User ID",          accessor: "userId" },
    { Header: "User Name",    accessor: "userName" },
    { Header: "Amount (USDT)",    accessor: "amount" },
    { Header: "Date",             accessor: "date" },
    { Header: "Remark",           accessor: "transactionRemark" },
    { Header: "Wallet Address", accessor: "walletAddress" },
  ];

  return (
    <div className="deposit">
      {processing && <Loader2 />}

      <h1 className="main-heading">USDT Withdrawal Requests</h1>
      <div className="button-group" style={{ margin: "1rem 0" }}>
        <button
          onClick={handleReturn}
          disabled={processing}
          style={{ background: "red" }}
        >
          Return Selected
        </button>
        <button
          onClick={handleApprove}
          disabled={processing}
          style={{ background: "green", marginLeft: "0.5rem" }}
        >
          Approve Selected
        </button>
      </div>

      <CustomTableCheckbox
        columns={columns}
        data={withdrawals}
        heading="Pending Payouts"
        onSelectedRows={onSelectedRows}
      />
    </div>
  );
}

export default USDTWithdrawal;
